import InputNumber, { InputNumberProps } from "@/shared/form/input-number";
import { useTranslations } from "use-intl";

export function DynamicAttributeFieldSimpleNumber({
  onChange,
  ...props
}: InputNumberProps) {
  const t = useTranslations("DynamicInputPlaceholder");

  return (
    <InputNumber
      data-testid={"dynamic-attribute-field-simple-number"}
      placeholder={t("Enter number")}
      onChange={(value) => onChange?.(value?.toString() ?? null)}
      step={"0.01"}
      {...props}
    />
  );
}
